import {
  Tooltip as ChakraTooltip,
  TooltipProps as ChakraTooltipProps,
  Text,
} from '@chakra-ui/react'
import { ReactNode, Ref, useDeferredValue } from 'react'

import { TooltipConfig } from '../../datatypes/dataTypeOptions'
import './Tooltip.css'

export interface ConditionalTooltipProps extends ChakraTooltipProps {
  children: ReactNode
  isDisabled?: boolean
  tooltipOptions?: TooltipConfig
}

const defaultTooltipOptions: TooltipConfig = {
  placement: 'top',
}

export const ConditionalTooltip = ({
  children,
  isDisabled,
  tooltipOptions,
  ...props
}: ConditionalTooltipProps) => {
  if (!tooltipOptions || isDisabled) return children
  const {
    label,
    asValue,
    useFallback: _useFallback,
    ...chakraTooltipOptions
  } = tooltipOptions

  return (
    <Tooltip
      children={<span className="conditional-tooltip-trigger">{children}</span>}
      {...defaultTooltipOptions}
      {...chakraTooltipOptions}
      label={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 0,
            alignItems: 'flex-start',
          }}
        >
          {label && <Text fontSize="12px">{label}</Text>}
          {asValue && (
            <Text fontSize="12px" fontWeight="700">
              {asValue}
            </Text>
          )}
        </div>
      }
      {...props}
    />
  )
}

interface TooltipProps extends ChakraTooltipProps {
  ref?: Ref<any>
}

export const Tooltip = ({ children, ref, ...props }: TooltipProps) => {
  const wrapTooltip = useDeferredValue(true, false)
  if (!wrapTooltip) return children

  return (
    <ChakraTooltip
      ref={ref}
      hasArrow
      // leave as first thing to try before reverting if there is an issue.
      // __css={{
      //   '& > span': {
      //     display: 'contents',
      //   },
      // }}
      openDelay={500}
      {...props}
    >
      {children}
    </ChakraTooltip>
  )
}
